export const KEY_PROVIDER_GOOGLE = `google`;
export const KEY_STORAGE_TYPE = `storage-type`;
export const KEY_SESSION_STORAGE = `sessionStorage`;
export const KEY_LOCAL_STORAGE = `localStorage`;
